// Shared project card — used in the home carousel and the /projects grid.
const ProjectCard = ({ p, i, onOpen, className = "" }) => (
  <button
    type="button"
    onClick={() => onOpen(i)}
    data-testid={`work-item-${i}`}
    className={`group relative text-left border border-white/10 bg-[#0d0d10] hover:border-white/25 transition-colors duration-500 ${className}`}
  >
    <div className="relative h-[220px] md:h-[250px] overflow-hidden">
      <img
        src={p.cover || p.images[0]}
        alt={p.title}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]"
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
      <div className="absolute bottom-0 inset-x-0 p-4">
        <h3 className="font-heading text-sm font-medium uppercase tracking-wide text-white">
          {p.title}
        </h3>
        <p className="mt-0.5 text-[10px] uppercase tracking-[0.25em] text-white/50">
          {p.location}
        </p>
        <span className="mt-2.5 inline-block border border-white/25 px-2.5 py-1 text-[9px] uppercase tracking-[0.2em] text-white/70">
          {p.tags[0]}
        </span>
      </div>
    </div>
  </button>
);

export default ProjectCard;
